'use client'

import NextLink from 'next/link'

/**
 * A top-level nav container of `type: 'link'`.
 *
 * The href is already normalized and locale-prefixed upstream (augment-nav-story
 * builds it through navLinkHref), so this only picks the element: `next/link`
 * for internal routes, so they get client-side navigation and stay in-app, and a
 * plain anchor for anything that leaves the site.
 */
export const NavContainerLink = ({
  href,
  target,
  className,
  onClick,
  children,
}: {
  href: string
  target?: string
  className?: string
  onClick?: () => void
  children: React.ReactNode
}) => {
  const isExternal = !href.startsWith('/') || href.startsWith('//') || target === '_blank'

  if (isExternal) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        data-tracking="ignore"
        className={className}
        onClick={onClick}
      >
        {children}
      </a>
    )
  }

  return (
    <NextLink href={href} prefetch={false} data-tracking="ignore" className={className} onClick={onClick}>
      {children}
    </NextLink>
  )
}
